module.exports = __webpack_public_path__ + "img/ret_pn.6795eaed.png";